import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import type {Option as MenuOption} from './menu';

import * as React from 'react';
import classify from 'src/utils/classify';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@spaced-out/ui-lib/lib/button'. '/Users/diwaker/SpacedOut/ui-server/node_modules/@spaced-out/ui-lib/lib/button/index.js' implicitly has an 'any' type.
import {UnstyledButton} from '@spaced-out/ui-lib/lib/button';
import {useContextMenu} from 'src/components/lib/context-menu';
import {Menu} from 'src/designSystem2021Components/menu';

import DownCaretIcon from 'src/images/designSystems2021/caret-down.svg?noAttrs';

import css from './buttons.css';


type ButtonProps = {
  onKeyPress?:
    | ((arg1: React.KeyboardEvent<HTMLElement>) => unknown)
    | null
    | undefined;
  onClick?:
    | ((arg1: React.SyntheticEvent<HTMLElement>) => unknown)
    | null
    | undefined;
  className?: string;
  icon?: React.ReactNode;
  value?: string; // deprecated, don't use this!;
  children?: React.ReactNode;
  type?: 'primary' | 'secondary' | 'tertiary' | 'selectable' | 'nav' | 'text';
  isError?: boolean;
  iconPosition?: 'left' | 'right';
  isSelectable?: boolean;
  isSelected?: boolean;
  disabled?: boolean;
  menuOptions?: Array<MenuOption>;
  size?: 'standard' | 'small';
};

/**
 * Our Design System button. It has lots of variants.
 *
 * Set the content with children and
 * @type {[type]}
 */
// @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<HTMLDivElement & RefAttributes<ButtonProps>>' is not assignable to type 'AbstractComponent<ButtonProps, HTMLDivElement>'.
export const Button: Flow_AbstractComponent<ButtonProps, HTMLDivElement> =
  React.forwardRef<ButtonProps, HTMLDivElement>(
    // @ts-expect-error - TS2345 - Argument of type '({ className, children, icon, iconPosition, value, type, isError, disabled, isSelected, isSelectable, size, ...props }: ButtonProps, ref: ForwardedRef<ButtonProps>) => Element' is not assignable to parameter of type 'ForwardRefRenderFunction<ButtonProps, HTMLDivElement>'.
    (
      {
        className,
        children,
        icon = null,
        iconPosition = 'left',
        value,
        type = 'primary',
        isError = false,
        disabled = false,
        isSelected = false,
        isSelectable = false,
        size = 'standard',
        ...props
      }: ButtonProps,
      ref,
    ) => (
      <UnstyledButton
        {...props}
        className={classify(className, css.button, {
          [css.primary]: !isSelectable && type === 'primary',
          [css.secondary]: !isSelectable && type === 'secondary',
          [css.tertiary]: type === 'tertiary',
          [css.nav]: type === 'nav',
          [css.text]: type === 'text',
          [css.selected]: isSelectable && isSelected,
          [css.unselected]: isSelectable && !isSelected,
          [css.error]: isError,
          [css.disabled]: disabled,
          [css.small]: size === 'small',
        })}
        ref={ref}
      >
        <div className={css.buttonRow}>
          {/* Has no icon, only child/value */}
          {icon == null ? (
            <div className={css.textContainerCenter}>{children ?? value}</div>
          ) : // has icon, but no child/value
          value == null && children == null ? (
            <div className={css.iconContainerCenter}>{icon}</div>
          ) : // has icon _and_ child/value
          iconPosition === 'left' ? (
            <>
              <div className={css.iconContainerLeft}>{icon}</div>
              <div className={css.textContainerRight}>{value || children}</div>
            </>
          ) : (
            <>
              <div className={css.textContainerLeft}>{children ?? value}</div>
              <div className={css.iconContainerRight}>{icon}</div>
            </>
          )}
        </div>
      </UnstyledButton>
    ),
  );

type MenuButtonProps = {
  menuOptions: Array<MenuOption>;
  onMenuSelect: (option: MenuOption) => unknown;
  selectedOption: MenuOption;
  children?: React.ReactNode;
  buttonProps: ButtonProps;
};

export const MenuButton = ({
  menuOptions,
  onMenuSelect,
  selectedOption,
  children,
  buttonProps,
}: MenuButtonProps) => {
  const [contextMenuRef, handleOpen] = useContextMenu({
    noArrow: true,
    noStyle: true,
    anchorPosition: 'start',
    justify: 'start',

    menuContent: (
      <div>
        <Menu
          options={menuOptions}
          onSelected={onMenuSelect}
          selectedOption={selectedOption}
        />
      </div>
    ),
  });
  return (
    // @ts-expect-error - TS2322 - Type 'ReactRef<HTMLElement>' is not assignable to type 'Ref<HTMLDivElement> | undefined'.
    <div ref={contextMenuRef} onClick={handleOpen}>
      <Button {...buttonProps} iconPosition="right" icon={<DownCaretIcon />}>
        {children}
      </Button>
    </div>
  );
};

export default Button;
